<script setup>
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import imgLogo from "@/assets/logo-nateevo.svg";

const router = useRouter();
const route = useRoute();
const showMenu = localStorage.getItem("a") === "aptd1";
const showMenuA = localStorage.getItem("r") === "admin0" || showMenu;
console.log(showMenu, showMenuA);

const menuItems = [
  {
    title: "Usuarios",
    route: "/dashboard/users",
    isShow: showMenuA,
    content: [{ title: "Crear", route: "/dashboard/users/create" }],
    icon: "fa-solid fa-user",
  },
  {
    title: "Contratos",
    route: "/dashboard/contracts",
    isShow: showMenuA,
    content: [{ title: "Crear", route: "/dashboard/contracts/create" }],
    icon: "fa-solid fa-file-contract",
  },
  {
    title: "Reglas",
    route: "/dashboard/rules",
    isShow: true,
    content: [{ title: "Crear", route: "/dashboard/rules/create" }],
    icon: "fa-solid fa-file-lines",
  },
  {
    title: "Proyectos",
    route: "/dashboard/proyects",
    isShow: true,
    content: [{ title: "Crear", route: "/dashboard/proyects/create" }],
    icon: "fa-solid fa-table-list",
  },
  {
    title: "Canales",
    route: "/dashboard/channels",
    isShow: true,
    content: [
      { title: "Crear", route: "/dashboard/channels/create" },
      /* { title: "Editar", route: "/dashboard/channels/edit" }, */
    ],
    icon: "fa-solid fa-diagram-project",
  },
  /*   {
    title: "Data",
    route: "/dashboard/data",
    isShow: showMenuA,
    content: [
      { title: "Estructura de Datos", route: "/dashboard/data/structure" },
      { title: "Esquemas", route: "/dashboard/data/schemes" },
    ],
  }, */
  {
    title: "Clientes",
    route: "/dashboard/clients",
    isShow: showMenu,
    content: [{ title: "Crear", route: "/dashboard/clients/create" }],
    icon: "fa-solid fa-users",
  },
  {
    title: "Listas",
    route: "/dashboard/lists",
    isShow: showMenu,
    content: [{ title: "Crear", route: "/dashboard/lists/create" }],
    icon: "fa-solid fa-clipboard-list",
  },
  { title: "Servicios API", isShow: true, route: "/dashboard/api", icon: "fa-solid fa-plug" },
];

const visibleMenuItems = menuItems.filter(item => item.isShow);

const activeItem = ref(-1);
function toggleItem(index, afterToggle) {
  activeItem.value = activeItem.value === index ? -1 : index;
  if (afterToggle) afterToggle();
}

function handleButtonClick(contentItem) {
  console.log("Botón clickeado:", contentItem.title);
  // redirigir a página específica
  router.push(contentItem.route);
}

function isActive(item) {
  return route.path.startsWith(item.route);
}

function navigate(path) {
  router.push(path);
}
</script>
<template>
  <aside class="sidebar">
    <div class="sidebar-logo">
      <router-link to="/dashboard">
        <img :src="imgLogo" alt="Logo" width="90" />
      </router-link>
    </div>
    <nav class="sidebar-menu">
      <ul>
        <li v-for="(item, index) in visibleMenuItems" :key="index" :class="['sidebar-item', { active: isActive(item) }]" @click="navigate(item.route)">
          <i :class="item.icon" class="sidebar-icon"></i>
          <span>{{ item.title }}</span>
        </li>
      </ul>
    </nav>
    <div v-if="showMenuA" class="sidebar-bottom" @click="navigate('/dashboard/settings')">
      <i class="fa-solid fa-gear sidebar-icon"></i>
      <span>Configuración</span>
    </div>
  </aside>
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";
.sidebar {
  width: 240px;
  min-width: 240px;
  max-width: 240px;
  height: 100%;
  min-height: 100vh;
  flex: 1 0 auto;
  border-radius: 16px;
  background: #18223B;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 0 1rem 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  overflow-y: auto;
}

.sidebar-logo {
  margin-bottom: 2.5rem;
  display: flex;
  justify-content: center;
  width: 100%;
}

.sidebar-menu {
  flex: 1;
  width: 100%;
  overflow-y: auto;
  max-height: calc(100vh - 180px); /* Account for logo and bottom section */
}

.sidebar-menu::-webkit-scrollbar {
  width: 4px;
}

.sidebar-menu::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-menu::-webkit-scrollbar-thumb {
  background-color: rgba(255,255,255,0.2);
  border-radius: 4px;
}

.sidebar-menu::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255,255,255,0.3);
}

.sidebar-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.sidebar-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1.1rem;
  padding: 0.9rem 1.2rem;
  color: #fff;
  font-size: 1.08rem;
  border-radius: 22px;
  margin-bottom: 0.5rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.sidebar-icon {
  font-size: 1.25rem;
  min-width: 22px;
  text-align: center;
}
.sidebar-item.active {
  background: #2a3b6a;
  color: #fff;
}
.sidebar-item:hover:not(.active) {
  background: rgba(255,255,255,0.07);
  color: #e0e6f6;
}
.sidebar-bottom {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.2rem;
  color: #bfc8e2;
  font-size: 1.08rem;
  border-radius: 22px;
  cursor: pointer;
  margin-top: auto;
  margin-bottom: 0.5rem;
  transition: background 0.2s, color 0.2s;
}
.sidebar-bottom .sidebar-icon {
  font-size: 1.25rem;
  min-width: 22px;
  text-align: center;
}
.sidebar-bottom:hover {
  background: #232c4b;
  color: #fff;
}
</style>
